import BackendQuery from 'decentralized/BackendQuery.js';
import {MIX} from './types.js';
import {NewMix} from 'decentralized/EthereumEvents.js';
import MixContract from 'decentralized/contracts/MixContract.js';

export const fetchMixes = async () => {
    let query = new BackendQuery(new MixContract().contractAddress)
        .from(NewMix)
        .select("mixHash")
        .select("previousHash")
        .select("title")
        .select("user");

    let results = await query.executeQuery(false);
    console.log('mix results =', results);
    return results.map(
        x => ({
            ... x,
            type: MIX
        }));
}
